/**
 * Created by anthony on 7/19/14.
 */
/**
 * Created by anthony on 7/14/14.
 */

var familyIndexModal = angular.module('familyIndexModal', []);
familyIndexModal.factory('FamilyIndexModalFactory', function($modal){
    var FamilyIndexModalFactory = function(controller, template, model)
    {
        this.controller = controller;
        this.template = template;
        this.model = model;
    }

    FamilyIndexModalFactory.prototype.initModal = function(familyIndex, index)
    {
        var parent = this;
        if (typeof index == 'undefined')
        {
            this.model.new();
            index = this.model.get().length - 1;
        }
        return $modal.open({
            templateUrl: this.template,
            controller: this.controller,
            resolve: {
                item: function()
                {
                    var item = angular.copy(parent.model.get(familyIndex)[index]);
                    return item;
                },
                index: function()
                {
                    return index;
                },
                familyIndex: function()
                {
                    return familyIndex;
                }
            }
        }).result.then(function(itemIndex) //Success
            {
                if (itemIndex.index != -1)
                    parent.model.get(familyIndex)[itemIndex.index] = itemIndex.item;
            },
            function () //Dismiss
            {
                if (typeof parent.model.get()[index].recordID == 'undefined') {
                    parent.model.get(familyIndex).pop();
                }
            });
    }
    return FamilyIndexModalFactory;
});